import { FieldConfig } from '../../restaurant/models';

/**
 * Returns map name (label) -> id
 */
export function getCustomFieldNameIdMap(partyFields: FieldConfig[]): Record<string, string> {
  const map: {[key: string]: string;} = {};
  for (let i = 0; i < partyFields.length; i++) {
    map[partyFields[i].name] = partyFields[i].id;
  }

  return map;
}
